import { useSelector } from "react-redux";
import { AccountRolesEnum } from "@tvg/ts-types/Account";
import { getEnableURPTalentPicksTool, userRoles } from "../redux/selectors";

const useCanCreatePicks = () => {
  const enableURPTalentPicksTool = useSelector(getEnableURPTalentPicksTool);
  const accountRoles = useSelector(userRoles);

  return (
    enableURPTalentPicksTool &&
    (accountRoles.includes(AccountRolesEnum.WAGEROPS) ||
      accountRoles.includes(AccountRolesEnum.TALENT))
  );
};

export default useCanCreatePicks;
